<div class="container">
    <mat-horizontal-stepper class="rounder" labelPosition="bottom" #stepper>

        <mat-step [stepControl]="detailsFormGroup">
          <form [formGroup]="detailsFormGroup">
            <ng-template matStepLabel>Quick Idea</ng-template>
            
            <h2 class="form-heading">Give Me Some Name</h2>
            <mat-form-field class="input-size" appearance="outline">
              <mat-label>Item Name</mat-label>
              <input matInput maxlength=50 formControlName="nameCtrl" required #itemName>
              <mat-hint align="end">{{itemName.value.length}} / 50</mat-hint>
            </mat-form-field>
            
            <mat-divider class="divide-and-rule"></mat-divider>

            <!-- TODO: need to make this work -->
            <h2 class="form-heading">Upload All Photos</h2>
            <button type="button" mat-raised-button (click)="fileInput.click()" color="primary">Upload Photos</button>
            <input #fileInput hidden type="file" accept="image/*,.HEIC" multiple (change)="uploadPhotos($event)">
            <mat-label *ngIf="photosEvent !== null">
              {{ photosEvent.target.files.length }} {{ photosEvent.target.files.length === 1 ? 'file' : 'files' }} attached
            </mat-label>
            <mat-divider class="divide-and-rule"></mat-divider>

            <div>
              <button mat-button matStepperNext>Next</button>
            </div>
          </form>
        </mat-step>

        <mat-step [stepControl]="locationFormGroup">
          <form [formGroup]="locationFormGroup">
            <ng-template matStepLabel>Preferred Pickup Location</ng-template>
            <h2 class="form-heading">Pick It Up</h2>
            <mat-form-field class="input-size" appearance="outline">
              <mat-label>Pickup Address</mat-label>
              <input matInput placeholder="Ex. Braeburn, Orchard Commons" formControlName="locationCtrl" required>
            </mat-form-field>
            
            <mat-divider class="divide-and-rule"></mat-divider>

            <h2 class="form-heading">Select the pickup location on the map below</h2>
            <google-map height="600px" width="100%" [center]="center" [zoom]="zoom" (mapClick)="addMarker($event)">
              <map-marker [position]="markerPosition"
                [options]="markerOptions" ></map-marker>
            </google-map>

            <mat-divider class="divide-and-rule"></mat-divider>

            <div>
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext>Next</button>
            </div>
          </form>
        </mat-step>

        <mat-step [stepControl]="describeFormGroup">
            <form [formGroup]="describeFormGroup">
              <h2 class="form-heading">Paint a Description</h2>
              <ng-template matStepLabel>A Short and Fitting Description</ng-template>
              <mat-form-field class="input-size" appearance="outline">
                <mat-label>Highlight the best features of your item</mat-label>
                <textarea rows=8 matInput formControlName="describeCtrl" required maxlength=500 #describe></textarea>
                <mat-hint align="end">{{ describe.value.length }} / 500</mat-hint>
              </mat-form-field>

              <mat-divider class="divide-and-rule"></mat-divider>

              <div>
                <button mat-button matStepperPrevious>Back</button>
                <button mat-button matStepperNext>Next</button>
              </div>
            </form>
        </mat-step>

        <mat-step [stepControl]="timingsFormGroup">
            <form [formGroup]="timingsFormGroup">
              <ng-template matStepLabel>Times that suit you</ng-template>
              <h2 class="form-heading">Notice Me</h2>
              <mat-form-field class="input-size" appearance="outline">
                <mat-label>How much notice do you need?</mat-label>
                <mat-select formControlName="noticeTimeCtrl">
                  <mat-option *ngFor="let notice of notices" [value]="getValue(notice)">
                    {{ notice }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-divider class="divide-and-rule"></mat-divider>

              <h2 class="form-heading">Select your preferred pickup time</h2>
              <mat-form-field class="half-input-size full-padding-right" appearance="outline">
                <mat-label>From</mat-label>
                <input matInput type="time" formControlName="fromTimeCtrl">
              </mat-form-field>
              <mat-form-field class="half-input-size" appearance="outline">
                <mat-label>To</mat-label>
                <input matInput type="time" formControlName="toTimeCtrl">
              </mat-form-field>

              <mat-divider class="divide-and-rule"></mat-divider>

              <h2 class="form-heading">Select windows of your time availability for the next 3 months</h2>
              <h3 class="form-heading">Add more windows with <mat-icon>add_circle_outline</mat-icon></h3>
              <div *ngFor="let window of windows; let i=index">
                <app-date-window (validity)="maintainWindowDates(i, $event)"></app-date-window>
                <mat-icon *ngIf="i === windows.length - 1" (click)="addMoreWindows()" class="add-icon">add_circle_outline</mat-icon>
              </div>
              
              <mat-divider class="divide-and-rule"></mat-divider>

              <div>
                <button mat-button matStepperPrevious>Back</button>
                <button mat-button matStepperNext>Next</button>
              </div>
            </form>
        </mat-step>

        <mat-step [stepControl]="moneyFormGroup">
            <form [formGroup]="moneyFormGroup">
              <h2 class="form-heading">Pricing</h2>
              <ng-template matStepLabel>Pricing</ng-template>
              <mat-form-field class="half-input-size full-padding-right" appearance="outline">
                <mat-label>Charge Per Day</mat-label>
                <span matPrefix>CA$ &nbsp;</span>
                <input matInput type="number" formControlName="priceCtrl" required>
              </mat-form-field>

              <mat-form-field class="half-input-size" appearance="outline">
                <mat-label>Deposit, if any</mat-label>
                <span matPrefix>CA$ &nbsp;</span>
                <input matInput type="number" formControlName="depositCtrl">
                <mat-hint>Let the renter know if you need any deposit</mat-hint>
              </mat-form-field>

              <mat-divider class="divide-and-rule"></mat-divider>

              <h2 class="form-heading">Payment</h2>
              <mat-form-field class="input-size" appearance="outline">
                <mat-label>Interac Email</mat-label>
                <input matInput type="text" formControlName="interacCtrl" required>
                <mat-hint>You will paid through Interac by the renter</mat-hint>
              </mat-form-field>

              <div *ngIf="uploading" class="spinner-wrapper">
                <mat-spinner></mat-spinner>
              </div>

              <mat-divider class="divide-and-rule"></mat-divider>

              <div>
                <button mat-button matStepperPrevious>Back</button>
                <button mat-button matStepperNext (click)="submitStepper()" [disabled]="uploading">Submit</button>
              </div>
            </form>
        </mat-step>

          
      </mat-horizontal-stepper>
</div>
